import { Component, inject } from '@angular/core';
import { SpinnerService } from '../../services/spinner/spinner.service';
import { CockpitDisplayStateService } from '../../../cockpit/shared/services/cockpit-display-state.service';

@Component({
  selector: 'app-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss'],
  standalone: true,
})
export class SpinnerComponent {
  readonly spinnerService = inject(SpinnerService);
  readonly cockpitDisplayStateService = inject(CockpitDisplayStateService);

  get isLoading(): boolean {
    return this.spinnerService.loading();
  }

  get isSlow(): boolean {
    return this.spinnerService.isSlowConnection();
  }
}
